@if (!isTrial) {
  <rt-badge
    [text]="badgeText || 'app.common.new' | translate"
    color="primary-gradient"
    rt-overlay-origin
    (click)="triggerTooltip($event); tooltipConfig ? (tooltip.open = !tooltip.open) : null"
    #tooltipOrigin="rtOverlayOrigin"
    [class.shimmer]="!tooltipVisited"
    class="shimmer-on-hover"
  >
  </rt-badge>

  <ng-template
    #tooltip="rtConnectedOverlay"
    rt-connected-overlay
    [offsetX]="tooltipConfig.offsetX ?? 0"
    [offsetY]="tooltipConfig.offsetY ?? 0"
    [origin]="tooltipOrigin"
    [positions]="tooltipPositions"
    hasBackdrop
    (backdropClick)="tooltip.open = false"
  >
    <rt-feature-tooltip
      [title]="tooltipConfig.title"
      [description]="tooltipConfig.description"
      [isNew]="tooltipConfig.isNew"
      [arrowPosition]="arrowPosition"
      [learnMore]="tooltipConfig?.learnMore"
    >
    </rt-feature-tooltip>
  </ng-template>
}
